import { html } from 'lit';
import componentStyles from './cta-buttons.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * Buttons for CTAs.
 *
 * @element cta-buttons
 */

export default class CtaButtons extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      items: { type: Object },
    };
  }


  render() {
    return html`
      <div class="cta-buttons">
        <ul class="cta-buttons__list">
          ${this.items.map(item => {
            if (item.icon) {
              return html`
                <li class="cta-buttons__item">
                  <hf-button
                    href="${item.url}"
                    target="${item.target ? item.target : '_self'}"
                    icon="${item.icon}"
                    type="${item.type}--grow"
                    disabled="${item.disabled}"
                    gtm="${item.gtm}"
                    >${item.text}</hf-button
                  >
                </li>
              `;
            }
          })}
        </ul>
      </div>
    `;
  }
}

customElements.define('hf-cta-buttons', CtaButtons);
